import styled from 'styled-components';
import { black, blue, border1, boxShadow1 } from 'utils/style/colors';

type ProjectTabItemProps = {
  isActive: boolean;
};

type ProjectMembersTabsProps = {
  isLast: boolean;
};

export const ProjectMembersHeader = styled('div')`
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  display: flex;
  padding: 2rem;
`;

export const ProjectMembersListWrapper = styled('ul')`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0;
  overflow: auto;
  overflow: overlay;
`;

export const ProjectMembersWrapper = styled('div')`
  background-color: var(--exact-white);
  border-bottom: 0.2rem solid #c8cee0;
  border-radius: 10px;
  box-shadow: ${boxShadow1};
  display: flex;
  flex-direction: column;
  //height: 100%;
  overflow: hidden;
`;

export const ProjectTabItem = styled('div')<ProjectTabItemProps>`
  color: ${(props) => (props.isActive ? blue : '#888')};
  cursor: pointer;
  flex: 1;
  font-weight: 500;
  margin-bottom: 1rem;
  margin-left: 0.2rem;
  text-align: center;
  transition: border 0.3s ease;
`;

export const ProjectMembersTabs = styled('div')<ProjectMembersTabsProps>`
  background: var(--exact-white);
  border-bottom: 0.2rem solid rgb(200, 206, 224, 0.6);
  display: flex;
  padding-top: 1rem;
  position: relative;
  transition: 0.3s ease;
`;

export const NoUserExists = styled('div')`
  margin: 10px;
  text-align: center;
  color: ${black};
`;
export const Item = styled('li')`
  align-items: center;
  margin: 0 1em !important;
  padding: 1em;
  border-bottom: ${border1};
  display: flex;
  // flex-direction: column;
  align-items: start;
  justify-content: space-between;
`;
